module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-sidebar__wrapper"
  }, [_c('div', {
    staticClass: "ksm-sidebar__container"
  }, [_vm._l((_vm.list), function(accor, i) {
    return [_c('div', {
      key: 't' + i,
      staticClass: "ksm-accordion__header",
      style: (i == 0 ? 'border-top-color:transparent' : '')
    }, [_c('div', {
      staticStyle: {
        "width": "22px",
        "height": "100%",
        "padding": "3px"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$_getIcon(_vm.openedAccordionId === i ? 'arrow-down.svg' : 'arrow-right.svg'))
      },
      on: {
        "click": function($event) {
          return _vm.clickAccordion(accor)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ksm-flex-1 ksm-flex",
      staticStyle: {
        "align-items": "center"
      },
      on: {
        "click": function($event) {
          return _vm.clickAccordion(accor)
        }
      }
    }, [_vm._v(_vm._s(accor.label))]), _vm._v(" "), (!_vm.hiddenToolbar) ? _c('div', {
      staticClass: "ksm-accordion__header-tool",
      staticStyle: {
        "width": "40px"
      }
    }, [_c('div', {
      staticClass: "ksm-icon-circle",
      style: (accor.checked ? 'background-color:' + accor.color : ''),
      on: {
        "click": function($event) {
          return _vm.clickColorCBX(accor)
        }
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      key: 'b' + i,
      staticClass: "ksm-accordion__body",
      class: accor.isExpand ? 'ksm-accordion__expand' : 'ksm-accordion__collapse'
    }, [_c('div', {
      staticClass: "ksm-orteundwege__accordion-container"
    }, [(accor.isInfoText) ? [_c('div', {
      staticClass: "ksm-hyphens",
      attrs: {
        "lang": "de"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.infoText)
      }
    })] : (accor.id !== 'merzgebiete') ? [_c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, _vm._l((accor.infoItems), function(infoItem, pi) {
      return _c('tr', {
        key: 'infoItem' + pi,
        staticClass: "ksm-orteundwege__accordion-row",
        class: infoItem === _vm.activeInfoItem ? '__' + accor.id + '-active' : '__' + accor.id,
        on: {
          "click": function($event) {
            return _vm.clickInfoItem(infoItem)
          }
        }
      }, [(['holland', 'merzabende'].indexOf(accor.id) > -1) ? [_c('td', [_vm._v(_vm._s(infoItem.row._datvon) + _vm._s(infoItem.row._datbis ? (' – ' + infoItem.row._datbis) : ''))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "min-width": "83pt"
        }
      }, [_vm._v(_vm._s(infoItem.row.stadtname ? infoItem.row.stadtname : infoItem.row.ortsname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(!infoItem.row.stadtname ? '' : infoItem.row.ortsname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(infoItem.row.short_113_html))])] : _vm._e(), _vm._v(" "), (['ausstellung'].indexOf(accor.id) > -1) ? [_c('td', {
        staticStyle: {
          "max-width": "50pt"
        }
      }, [_vm._v(_vm._s(infoItem.row._datvon) + _vm._s(infoItem.row._datbis ? (' – ' + infoItem.row._datbis) : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(infoItem.row.titel))])] : _vm._e(), _vm._v(" "), (['veranstaltung', 'veröffentlichung', 'institutionen'].indexOf(accor.id) > -1) ? [_c('td', [_vm._v(_vm._s(infoItem.row._datvon) + _vm._s(infoItem.row._datbis ? (' – ' + infoItem.row._datbis) : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(infoItem.row.stadtname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(infoItem.row.ortsname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(infoItem.row.titel))])] : _vm._e()], 2)
    }), 0)] : (accor.id === 'merzgebiete') ? _vm._l((accor.merzgebiete), function(mg, mi) {
      return _c('div', {
        key: 'mg' + mi
      }, [_c('div', {
        staticClass: "ksm-flex-y-center"
      }, [_c('div', {
        staticClass: "ksm-orteundwege__merzgebiete-icon",
        style: (mg.checked ? 'background-color:' + mg.color : ''),
        on: {
          "click": function($event) {
            mg.checked = !mg.checked
          }
        }
      }), _vm._v("\n                " + _vm._s(mg.name) + "\n              ")])])
    }) : _vm._e()], 2)])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9255ee2a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/orte/Sidebar.OrteUndWege.vue
// module id = 1986
// module chunks = 1